import Raven from "raven-js";
import { configurePageParams } from "@orange-marmalade/paginate-this";

if (process.env.NODE_ENV !== "development") {
  Raven.config(process.env.SENTRY_DSN).install();
}

configurePageParams({
  perPage: "limit",
  sortOrder: "reverse",
  sortReverse: true
});



// WEBPACK FOOTER //
// ./app/globalSettings.js